<template>
  <div class="tab-content">
    <h4 class="section-title">Data Pendidikan</h4>

    <div class="form-fields">
      <div class="field">
        <label>Asal Negara Universitas <span class="required">*</span></label>
        <div class="field-value">{{ data.asalNegara }}</div>
      </div>

      <div class="field">
        <label>Asal Fakultas Kedokteran <span class="required">*</span></label>
        <div
          v-for="(f, i) in parsedFakultas"
          :key="i"
          class="field-value"
          :style="i > 0 ? 'margin-top: 4px' : ''"
        >{{ f }}</div>
      </div>

      <div class="field">
        <label>Subspesialis <span class="required">*</span></label>
        <div class="field-value">{{ data.subspesialis }}</div>
      </div>

      <div class="two-col">
        <div class="field">
          <label>Tahun Masuk <span class="required">*</span></label>
          <div class="field-value">{{ data.tahunMasuk }}</div>
        </div>
        <div class="field">
          <label>Tahun Lulus <span class="required">*</span></label>
          <div class="field-value">{{ data.tahunLulus }}</div>
        </div>
      </div>

      <div class="field">
        <label>Nomor Ijazah <span class="required">*</span></label>
        <div class="field-value">{{ data.nomorIjazah }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MemberApplicationTabDataPendidikan',
  props: {
    data: { type: Object, required: true },
  },
  computed: {
    parsedFakultas() {
      const raw = this.data.asalFakultas
      if (!raw) return ['-']
      const list = raw.split(',').map(s => s.trim()).filter(Boolean)
      return list.length ? list : ['-']
    },
  },
}
</script>

<style scoped>
.tab-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.section-title {
  font-size: 20px;
  font-weight: 700;
  color: #282828;
  margin: 0;
}

.form-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field label {
  font-size: 14px;
  font-weight: 700;
  color: #444;
}

.required {
  color: #dc3545;
}

.field-value {
  background: #e4e9f0;
  border: 1px solid #e4e9f0;
  border-radius: 6px;
  padding: 4px 16px;
  min-height: 32px;
  font-size: 14px;
  color: #444;
  line-height: 22px;
  display: flex;
  align-items: center;
}
</style>
